import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as L, computed as n, createElementBlock as f, openBlock as l, normalizeClass as C, createCommentVNode as c, Fragment as z, createBlock as m, unref as r, mergeProps as k, createVNode as v, withCtx as h, createTextVNode as T, toDisplayString as S, createElementVNode as y, useId as N, ref as $, onMounted as F, onUnmounted as O, renderSlot as H, normalizeProps as w, guardReactiveProps as R } from "vue";
import { LandingContentBlock as q } from "@rei/landing-content-block";
import { ScrollCarousel as E } from "@rei/recommendations-slider";
import { CdrSpaceThreeQuarterX as D, CdrBreakpointMd as U, CdrBreakpointLg as A } from "@rei/cdr-tokens";
import { CdrImg as V, CdrButton as Q, CdrLink as M, CdrText as B, CdrRating as W } from "@rei/cedar";
import X from "@rei/landing-image-component";
import j from "@rei/landing-badge";
const G = ["data-location-index"], J = {
  key: 0,
  class: "slide__button-container"
}, K = /* @__PURE__ */ L({
  __name: "SlideComponent",
  props: {
    cta: {
      default: () => ({})
    },
    media: {
      default: () => ({})
    },
    slideStyle: {
      default: "lifestyle-portrait"
    },
    lastSlide: {
      type: Boolean
    },
    tabindex: {
      default: -1
    },
    index: {
      default: 0
    }
  },
  setup(d) {
    const t = d, i = n(() => t.slideStyle === "lifestyle-portrait" || t.slideStyle === "lifestyle-portrait-sm"), u = n(() => t.slideStyle === "lifestyle-square"), e = n(() => {
      var s, a, g, b;
      return !((a = (s = t.media) == null ? void 0 : s.images) != null && a.xs || (b = (g = t.media) == null ? void 0 : g.images) != null && b.lg);
    }), _ = n(() => t.slideStyle === "lifestyle-portrait-sm"), o = n(() => _.value ? "small@xs small@sm small@md" : "medium"), p = n(() => t.index + 1);
    return (s, a) => (l(), f("div", {
      class: C(["slide", s.slideStyle]),
      "data-location-index": p.value
    }, [s.media ? (l(), f(z, {
      key: 0
    }, [e.value ? (l(), m(r(V), {
      key: 1,
      alt: s.media.alt,
      src: s.media.src,
      class: "slide__image",
      loading: "lazy"
    }, null, 8, ["alt", "src"])) : (l(), m(r(X), k({
      key: 0
    }, s.media, {
      class: "slide__image"
    }), null, 16))], 64)) : c("", !0), s.cta ? (l(), f(z, {
      key: 1
    }, [i.value ? (l(), f("div", J, [v(r(Q), {
      class: "slide__cta",
      href: s.cta.target,
      tag: "a",
      modifier: "secondary",
      "data-focus": "",
      size: o.value,
      tabindex: s.tabindex
    }, {
      default: h(() => [T(S(s.cta.text), 1)]),
      _: 1
    }, 8, ["href", "size", "tabindex"])])) : c("", !0), u.value ? (l(), m(r(M), {
      key: 1,
      href: s.cta.target,
      tabindex: s.tabindex,
      modifier: "standalone",
      class: "slide__link",
      "data-focus": ""
    }, {
      default: h(() => [T(S(s.cta.text), 1)]),
      _: 1
    }, 8, ["href", "tabindex"])) : c("", !0)], 64)) : c("", !0)], 10, G));
  }
}), P = (d, t) => {
  const i = d.__vccOpts || d;
  for (const [u, e] of t)
    i[u] = e;
  return i;
}, Y = /* @__PURE__ */ P(K, [["__scopeId", "data-v-85ba7163"]]), Z = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), I = (d) => Z.format(d), x = {
  class: "price-component"
}, ee = {
  key: 0
}, te = {
  class: "price-component__compare-price"
}, se = /* @__PURE__ */ L({
  __name: "PriceComponent",
  props: {
    highestPrice: {
      default: 0
    },
    lowestPrice: {
      default: 0
    },
    fullPrice: {
      default: 0
    },
    percentOff: {
      default: 0
    },
    sale: {
      type: Boolean,
      default: !1
    }
  },
  setup(d) {
    const t = d, i = n(() => I(t.lowestPrice)), u = n(() => I(t.highestPrice)), e = n(() => t.highestPrice !== t.fullPrice), _ = n(() => t.sale && t.highestPrice !== t.fullPrice ? I(t.fullPrice) : !1);
    return (o, p) => (l(), f("div", x, [v(r(B), {
      "data-ui": "price-component-price",
      class: C(["price-component__price", {
        "is-sale": e.value
      }])
    }, {
      default: h(() => [y("span", {
        "data-ui": "price-component-lowest-price",
        class: C([{
          "is-sale": o.sale
        }])
      }, S(i.value), 3), o.lowestPrice !== o.highestPrice ? (l(), f("span", ee, " – " + S(u.value), 1)) : c("", !0)]),
      _: 1
    }, 8, ["class"]), _.value ? (l(), m(r(B), {
      key: 0,
      "data-ui": "price-component-compare-price",
      class: "price-component__price"
    }, {
      default: h(() => [p[0] || (p[0] = y("span", {
        class: "sr-only"
      }, "Compared to ", -1)), y("span", te, S(_.value), 1)]),
      _: 1,
      __: [0]
    })) : c("", !0), o.percentOff && o.percentOff > 0 ? (l(), m(r(B), {
      key: 1,
      class: "price-component__percent-off"
    }, {
      default: h(() => [T(" Save up to " + S(o.percentOff) + "% Off ", 1)]),
      _: 1
    })) : c("", !0)]));
  }
}), le = /* @__PURE__ */ P(se, [["__scopeId", "data-v-c84dd3dc"]]), ae = {
  class: "landing-product-tile"
}, ie = {
  class: "landing-product-tile__img-wrap"
}, ne = {
  class: "landing-product-tile__content"
}, re = ["innerHTML"], oe = ["innerHTML"], de = /* @__PURE__ */ L({
  __name: "ProductTile",
  props: {
    brand: {
      default: ""
    },
    href: {
      default: ""
    },
    price: {
      default: () => ({})
    },
    title: {
      default: ""
    },
    media: {
      default: () => ({})
    },
    badge: {
      default: () => ({})
    },
    rating: {
      default: () => ({})
    },
    lastSlide: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      default: -1
    }
  },
  setup(d) {
    const t = d, i = n(() => {
      var e;
      return ((e = t.rating) == null ? void 0 : e.averageRating) || 0;
    }), u = n(() => {
      var e;
      return ((e = t.rating) == null ? void 0 : e.count) || 0;
    });
    return (e, _) => (l(), f("div", ae, [y("div", ie, [e.media && e.media.uri ? (l(), m(r(V), {
      key: 0,
      src: e.media.uri,
      alt: e.title,
      class: "landing-product-tile__img"
    }, null, 8, ["src", "alt"])) : c("", !0), e.badge && e.badge.text ? (l(), m(r(j), k({
      key: 1,
      class: "landing-product-tile__badge"
    }, e.badge), null, 16)) : c("", !0)]), y("div", ne, [y("p", {
      class: "landing-product-tile__brand",
      innerHTML: e.brand
    }, null, 8, re), v(r(M), {
      href: e.href,
      modifier: "standalone",
      class: "landing-product-tile__link",
      tabindex: e.tabindex
    }, {
      default: h(() => [y("h3", {
        class: "landing-product-tile__title",
        tag: "h3",
        innerHTML: e.title
      }, null, 8, oe)]),
      _: 1
    }, 8, ["href", "tabindex"]), v(le, k({
      class: "landing-product-tile__price"
    }, e.price), null, 16), v(r(W), {
      rating: i.value,
      count: u.value,
      class: "landing-product-tile__rating",
      size: "small",
      compact: ""
    }, null, 8, ["rating", "count"])])]));
  }
}), ce = /* @__PURE__ */ P(de, [["__scopeId", "data-v-adf45441"]]), ue = {
  key: 0,
  class: "filmstrip-carousel__content"
}, pe = /* @__PURE__ */ L({
  __name: "LandingFilmstripCarouselComponent",
  props: {
    slides: {
      default: () => []
    },
    slideStyle: {
      default: "Lifestyle 3:4 Large"
    },
    content: {
      default: () => ({})
    },
    slidesVisible: {
      default: 3
    },
    prefixAriaLabel: {
      default: "slide"
    },
    filmstripId: {
      default: "filmstrip-1"
    }
  },
  setup(d) {
    const t = N(), i = d, u = n(() => {
      const a = "lifestyle-portrait";
      return {
        "Lifestyle 3:4 Small": "lifestyle-portrait-sm",
        "Lifestyle 3:4 Large": a,
        "Lifestyle 1:1": "lifestyle-square"
      }[i.slideStyle] || a;
    }), e = n(() => i.slides.map((a, g) => ({
      key: g.toString(),
      props: {
        ...a,
        slideStyle: u.value,
        index: g
      }
    }))), _ = n(() => i.slideStyle === "Product 1:1"), o = $(i.slidesVisible), p = $(2);
    function s() {
      const {
        clientWidth: a
      } = window.document.body;
      switch (!0) {
        case a >= Number(A):
          o.value = i.slidesVisible, p.value = i.slidesVisible - 1;
          break;
        case a >= Number(U):
          o.value = 3, p.value = 2;
          break;
        default:
          o.value = 2, p.value = 1;
      }
    }
    return F(() => {
      s(), window.addEventListener("resize", s);
    }), O(() => {
      window.removeEventListener("resize", s);
    }), (a, g) => (l(), f("div", {
      class: C(["filmstrip-carousel", [{
        "filmstrip-carousel--has-content": !!a.content
      }]])
    }, [a.content ? (l(), f("div", ue, [v(r(q), w(R(a.content)), null, 16)])) : c("", !0), H(a.$slots, "above-carousel", {}, void 0, !0), v(r(E), {
      id: r(t),
      class: "filmstrip-carousel__container",
      slides: e.value,
      "slides-gap": parseInt(r(D), 10),
      "slides-to-show": o.value,
      "slides-to-scroll": p.value,
      "is-showing-arrows": !0,
      "focus-selector": ":first-child a"
    }, {
      slide: h((b) => [_.value ? (l(), m(ce, w(k({
        key: 0
      }, {
        ...b
      })), null, 16)) : (l(), m(Y, w(k({
        key: 1
      }, {
        slideStyle: a.slideStyle,
        ...b
      })), null, 16))]),
      _: 1
    }, 8, ["id", "slides", "slides-gap", "slides-to-show", "slides-to-scroll"])], 2));
  }
}), ke = /* @__PURE__ */ P(pe, [["__scopeId", "data-v-df861c71"]]);
export {
  ke as default
};
